import { Link } from "react-router-dom";

import { Empty } from "@/components/ui/Empty";
import { useI18n } from "@/i18n";

export function NotFoundPage() {
  const { t } = useI18n();
  return (
    <Empty
      title={t("notFound.title")}
      action={
        <Link
          to="/"
          className="text-sm font-medium text-accent-text underline-offset-4 hover:underline"
        >
          {t("notFound.back")}
        </Link>
      }
    >
      {t("notFound.body")}
    </Empty>
  );
}
